import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import type { SxProps } from '@mui/material/styles'

import { H3, P } from '@mxenabled/mxui'
import { ChevronRight } from '@mxenabled/mx-icons'

import { WidgetContainerProvider } from '../context'
import { useDimensions } from '../hooks/useDimensions'

interface MicroWidgetContainerProps {
  className?: string
  ctaLabel: string
  onCTAClick: () => void
  subHeader?: string
  sx?: SxProps
  title: string
  variant?: 'borderless' | 'card'
}

const MicroWidgetContainer: React.FC<React.PropsWithChildren<MicroWidgetContainerProps>> = ({
  children,
  className,
  ctaLabel,
  onCTAClick,
  subHeader,
  sx,
  title,
  variant = 'borderless',
}) => {
  const [containerRef, { height, width }] = useDimensions()

  const content = (
    <>
      <CardHeader
        action={
          <Button
            endIcon={<ChevronRight size={20} />}
            onClick={onCTAClick}
            size="small"
            variant="text"
          >
            {ctaLabel}
          </Button>
        }
        subheader={
          subHeader && (
            <P sx={{ color: 'text.secondary' }} variant="body2">
              {subHeader}
            </P>
          )
        }
        sx={{ p: 0, pb: 8, width: 'calc(100% - 8px)', '& .MuiCardHeader-action': { mt: 0 } }}
        title={<H3 sx={{ width: 'calc(100% - 10px)' }}>{title}</H3>}
      />

      <CardContent ref={containerRef} sx={{ p: 0, ':last-child': { pb: 0 } }}>
        <WidgetContainerProvider availableHeight={height} availableWidth={width}>
          {children}
        </WidgetContainerProvider>
      </CardContent>
    </>
  )

  if (variant === 'borderless') return content

  return (
    <Card className={className} sx={{ alignItems: 'center', p: 16, ...sx }}>
      {content}
    </Card>
  )
}

export default MicroWidgetContainer
